/**
 * Varlıklar ekranı seçim durumu. TKP-124: zincir `birim → süreç → veri düğümü → ilgili kişi`; veri kaynağı artık
 * Varlıklar zincirinin bir seviyesi DEĞİL, düğümün envanter özelliği (düğüm formundaki "Kaynaklar" seçicisi).
 * K5 korunur: kaynağa bağlı altı özellik süreç×kaynak seviyesinde, Envanter ekranında süreç satırının altında.
 * (Önce TKP-27 / 6.1: kaynak sürecin altında bağımsız bir kutuydu. Veri kategorisi kutusu K4 ile kalkmıştı.)
 */
const LEVELS = ["department", "process", "data", "datasubject"];

/** Bir seviye seçilince/temizlenince temizlenecek alt seviyeler. */
export const clearedBy = (level) => {
  if (level === "department") return ["department", "process", "data", "datasubject"];
  if (level === "process") return ["process", "data", "datasubject"];
  if (level === "data") return ["data", "datasubject"];
  if (level === "datasubject") return ["datasubject"];
  return [];
};

const SELECTED_ENTITY_STORE = {
  department: "organizationDepartment",
  process: "organizationDepartmentProcess",
  data: "organizationProcessData",
  datasubject: "organizationProcessDataDatasubject",
};

const setLevel = (state, level, value) => {
  if (state[level] == value) return;
  clearedBy(level).forEach((l) => (state[l] = undefined));
  state[level] = value;
};

const select = (level) => async ({ getters, commit }, item) => {
  const next = getters[level]?._id == item?._id ? undefined : item;
  commit(level, next);
  commit(`${SELECTED_ENTITY_STORE[level]}/selectedEntity`, next, { root: true });
};

export const entityBoxes = {
  namespaced: true,
  state: Object.fromEntries(LEVELS.map((l) => [l, undefined])),
  getters: Object.fromEntries(LEVELS.map((l) => [l, (state) => state[l]])),
  mutations: {
    clear: (state) => LEVELS.forEach((l) => (state[l] = undefined)),
    clearFrom: (state, level) => clearedBy(level).forEach((l) => (state[l] = undefined)),
    ...Object.fromEntries(LEVELS.map((l) => [l, (state, value) => setLevel(state, l, value)])),
  },
  actions: {
    selectDepartment: select("department"),
    selectProcess: select("process"),
    selectData: select("data"),
    selectDatasubject: select("datasubject"),
  },
};
